import { render, staticRenderFns } from "./ChatMessageComponent.vue?vue&type=template&id=6a862619&"
import script from "./ChatMessageComponent.vue?vue&type=script&lang=js&"
export * from "./ChatMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a862619')) {
      api.createRecord('6a862619', component.options)
    } else {
      api.reload('6a862619', component.options)
    }
    module.hot.accept("./ChatMessageComponent.vue?vue&type=template&id=6a862619&", function () {
      api.rerender('6a862619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatMessageComponent.vue"
export default component.exports